import React from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error("Render error caught by ErrorBoundary:", error, info?.componentStack);
    }

    render() {
        if (this.state.error) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-background px-4" data-testid="error-boundary">
                    <div className="max-w-md w-full text-center space-y-4">
                        <div className="w-12 h-12 rounded-full bg-loss/15 text-loss flex items-center justify-center mx-auto">
                            <AlertTriangle className="w-6 h-6" />
                        </div>
                        <h1 className="font-heading text-xl font-bold">Something went wrong</h1>
                        <p className="text-sm text-muted-foreground">
                            This page hit an unexpected error. Reloading usually fixes it.
                        </p>
                        <pre className="text-left text-[11px] text-muted-foreground bg-muted/50 rounded-lg p-3 overflow-auto max-h-40 whitespace-pre-wrap" data-testid="error-boundary-message">
                            {String(this.state.error?.message || this.state.error)}
                        </pre>
                        <div className="flex gap-2 justify-center">
                            <Button onClick={() => window.location.reload()} data-testid="error-boundary-reload">Reload</Button>
                            <Button variant="outline" onClick={() => { window.location.href = "/"; }} data-testid="error-boundary-home">Go to Dashboard</Button>
                        </div>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
